<template>
    <div class="reg-dialog" v-if="visibleDialog">
        <el-dialog :visible="visibleDialog" :width="width" :title="title" :close-on-click-modal='true'
            :close-on-press-escape='false' @close="visibleDialog = false">
            <div class="change-btn-box  dialog-water" v-if="visibleDialog">
                <div class="change-radio">
                    <div><el-input clearable v-model="qName" size="mini" v-show="showInput" placeholder="请输入"
                            @change="inputChange"></el-input></div>
                    <searchList ref="searchListRef" :searchListConfig="config.searchListConfig" :roleCode="roleCode"
                        @search-handle="searchHandle" :searchInitData="getParams" :currentRole="currentRole"
                        :searchOptionsList="{}" />
                    <!-- <slot name="searchBox"></slot> -->
                </div>
                <!-- 表格    -->
                <div :key="tableKey">
                    <table-box ref="tableBusRef" v-loading="subTabTable.tableLoading" :index="config.index"
                        :columns="_columns" :rows="subTabTable.totalData" :default-sort="config.defaultSort"
                        @sort-change="handleSort" height="397px" class="customer-table home-dialog-table">
                        <template v-slot:col-append="{ col, row }">
                            <span v-if="['angleName'].includes(col.prop)">
                                <span size="mini" type="text"
                                    class="mip-page-link no-wrap bigData-btn-home-page-opportunity-link"
                                    @click="openDialog(row)">{{
                                        row[col.prop]
                                    }}</span>
                            </span>
                            <span v-else-if="['industryName'].includes(col.prop)">
                                <span size="mini" type="text"
                                    class="mip-page-link no-wrap bigData-btn-home-page-opportunity-link"
                                    @click="openDialog(row)">{{
                                        row[col.prop]
                                    }}</span>
                            </span>
                            <span v-else-if="['siteNameLev2'].includes(col.prop)">
                                <span size="mini" type="text"
                                    class="mip-page-link no-wrap bigData-btn-home-page-opportunity-link"
                                    @click="openSiteDialog(row)">{{
                                       row[col.prop]
                                    }}</span>
                            </span>
                            <span v-else-if="['customerName'].includes(col.prop)">
                                <span size="mini" type="text"
                                    class="mip-page-link no-wrap bigData-btn-home-page-opportunity-link"
                                    @click="openCustomerDialog(row)">{{
                                        row[col.prop]
                                    }}</span>
                            </span>
                            <span v-else-if="['lmsCustomerName'].includes(col.prop)">
                                <span size="mini" type="text" class="no-wrap">{{
                                    row[col.prop]
                                }}</span>
                            </span>
                            <span
                                v-else-if="['incomeFeeY2Y', 'incomeFeeM2M', 'amtDue', 'amtOverdue'].includes(col.prop)">
                                <span size="mini" type="text" :class="[getCellClass(row[col.prop])]">{{
                                    row[col.prop]
                                }}</span>
                            </span>
                        </template>
                        <template v-slot:nest-table="{ col }">
                            <el-table-column v-for="(item, index) in col.children" :key="index" :prop="item.prop"
                                :label="item.label" align="center">
                                <template v-slot="{ row }">
                                    <span v-if="['angleName'].includes(item.prop)">
                                        <span size="mini" type="text"
                                            class="mip-page-link"
                                            @click="openDialog(row)">{{
                                                row[item.prop]
                                            }}</span>
                                    </span>
                                    <span v-else-if="['industryName'].includes(item.prop)">
                                        <span size="mini" type="text"
                                            class="mip-page-link"
                                            @click="openDialog(row)">{{
                                                row[item.prop]
                                            }}</span>
                                    </span>
                                    <span v-else-if="['siteNameLev2'].includes(item.prop)">
                                        <span size="mini" type="text"
                                            class="mip-page-link"
                                            @click="openSiteDialog(row)">{{
                                                row[item.prop]
                                            }}</span>
                                    </span>
                                    <span v-else-if="['customerName'].includes(item.prop)">
                                        <span size="mini" type="text"
                                            class="mip-page-link"
                                            @click="openCustomerDialog(row)">{{
                                                row[item.prop]
                                            }}</span>
                                    </span>
                                    <span v-else-if="['lmsCustomerName'].includes(item.prop)">
                                        <span size="mini" type="text" class="no-wrap">{{
                                            row[item.prop]
                                        }}</span>
                                    </span>
                                    <span
                                        v-else-if="['incomeFeeY2Y', 'incomeFeeM2M', 'amtDue', 'amtOverdue'].includes(item.prop)">
                                        <span size="mini" type="text" :class="[getCellClass(row[item.prop])]">{{
                                            row[item.prop]
                                        }}</span>
                                    </span>
                                    <span v-else>{{ row[item.prop] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </table-box>
                    <el-pagination v-if="config.page" class="income-pagination-page"
                        :current-page.sync="subTabTable.pageNo" @current-change="subTabTable.pageChange"
                        @size-change="subTabTable.sizeChange" :pageSize="subTabTable.pageSize" :total="totalNum"
                        layout="total, sizes, prev, pager, next, jumper">
                    </el-pagination>
                </div>

            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, toRefs, onMounted, computed } from '@vue/composition-api';
// import lotsButton from '@/components/lots/lotsButton';
import tableBox from '@/components/lots/tableBox/Index';
// import searchBox from '@/components/lots/searchBox';
// import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import store from '@/store/index';
import _ from 'lodash';
import searchList from '@/views/index/searchList/Index.vue';
// import { config as tableConfig } from './config.js';
import bigDataLog from '@/utils/bigDataLog.js';
export default {
    components: { tableBox, searchList },
    props: {
        detailDataLocal: {
            type: Object,
            return: () => { }
        },
        config: {
            type: Object,
            return: () => { }
        },
        getParams: {
            type: Object,
            return: () => { }
        },
        roleCode: {
            type: Array,
            return: () => []
        },
        currentRole: {
            type: Object,
            return: () => { }
        },
        currentUser: {
            type: Object,
            return: () => { }
        },
        title: {
            type: String,
            return: () => ''
        },
        needCostType: {
            type: Boolean,
            return: () => false
        },
        width: {
            type: String,
            default: '70%'
        },
        beforeRequest: {
            type: Function,
            default: (val = {}) => { return val; }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const { userCode } = store.getters.user;
        // const config = reactive(tableConfig);
        const state = reactive({
            pageSize: 20,
            _
        });

        const visibleDialog = ref(false);
        const visibleSearch = ref(true);
        const emit = setupContext.emit;
        const prevGetListParmas = ref({});
        // eslint-disable-next-line no-magic-numbers
        class ContractListClass extends AdvanceListClass {
            // eslint-disable-next-line complexity
            beforeGetList(condition) {
                condition.userCode = userCode;
                condition = { ...props.getParams, ...setParamsList() };
                if (condition.qName) {
                    condition.qName = `'${qName.value}'` || `'${condition.qName}'`;
                }
                if (orderBy.value) {
                    condition.orderBy = orderBy.value;
                    condition.orderByType = orderByType.value;
                }
                // 默认有分页的接口就不走特殊分页处理方式
                if (props.config.defaultPage) {
                    condition.pageNo = subTabTable.pageNo?.value - 1 || 0;
                    condition.pageSize = subTabTable.pageSize?.value || 10;
                    // 无分页走特殊处理方式
                } else if (props.config.page) {
                    condition.pageNo = subTabTable.pageNo?.value || 0;
                    condition.pageSize = subTabTable.pageSize?.value || 10;
                    if (condition.pageNo === 1) {
                        condition.pageNo = 0;
                    } else if (condition.pageNo > 1) {
                        condition.pageNo = (condition.pageNo - 1) * condition.pageSize;
                    }
                }
                // 执行外部传入的请求前处理函数
                if (props.beforeRequest && typeof props.beforeRequest === 'function') {
                    const result = props.beforeRequest(condition);
                    prevGetListParmas.value = _.cloneDeep(result);
                    return result;
                }
                prevGetListParmas.value = _.cloneDeep(condition);
                return condition;
            };
            async afterGetList(res) {
                if (+res.code === 0) {
                    const afterRes = _.get(props.config, 'afterResponse');
                    if (afterRes && _.isFunction(afterRes)) {
                        res = afterRes(res);
                    }
                    const afterResponseBeforeReq = _.get(props.config, 'afterResponseBeforeRequest');
                    if (afterResponseBeforeReq && _.isFunction(afterResponseBeforeReq) && prevGetListParmas.value.qName === "''") {
                        const res2 = await afterResponseBeforeReq(prevGetListParmas.value);
                        res.data.unshift(res2);
                    }
                    this.totalData.value = res.data;
                    this.pageTotal.value = res.data;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.tableBusRef.$refs.elTable.doLayout(); // 解决表格错位
                });
            };
        }
        const subTabTable = new ContractListClass({
            Api: {
                listApi: props.config.listApi // 查询接口
            }
        });
        const confirm = () => {
            visibleDialog.value = false;
        };
        const currentOptions = ref([]);
        const respVersion = ref('');
        const otherParams = ref({});
        const show = async (val) => {
            visibleDialog.value = true;
            orderBy.value = '';
            orderByType.value = '';
            otherParams.value = val;
            if (props.getParams?.qName) {
                qName.value = ``;
            }
            // 去掉不用的参数，这个row只用来暴露给外层取数
            delete otherParams.value.row;
            setupContext.root.$nextTick(() => {
                setupContext.refs.searchListRef.initSearchDataFunc(val);
            });
        };

        const getCellClass = (data) => {
            const val = processString(data);
            if (val > 0) {
                return 'c-item-up-bg';
            } else if (val < 0) {
                return 'c-item-down-bg';
            } else {
                return '';
            }
        };
        const processString = (val) => {
            // 移除所有百分号
            const stringWithoutPercent = val?.toString().replace(/[^0-9\.\+-]/g, '');
            // 转换为数字
            const numericValue = parseFloat(stringWithoutPercent);
            return numericValue;
        };
        const errlist = [undefined, null, ''];
        const changeIconActive = (row, prop) => {
            return errlist.includes(row) ? '' : 'icon-active';
        };
        const dataChanged = (data) => {
            respVersion.value = data;
            subTabTable.getList();
            bigDataLog.sendDetailMessageByKey('bigData-btn-home-page-regis-score-radio');
        };
        const setStrFormat = (val) => {
            if (!Array.isArray(val)) return val;
            return val?.map(item => `'${item}'`).join(',') || '';
        };
        const setCommaStrFormat = (val) => {
            let str = '';
            for (let i = 0; i < val.length; i++) {
                if (val[i].indexOf(',') >= 0) {
                    const arr = val[i].split(',');
                    for (let j = 0; j < arr.length; j++) {
                        str += "'" + arr[j] + "',";
                    }
                } else {
                    str += "'" + val[i] + "',";
                }
            }
            return str.substring(0, str.length - 1); // 删除最后的逗号
        };
        const isYear = computed(() => {
            return searchData.value?.timeStatus === 'year';
        });
        const searchData = ref({});
        // 筛选赋值
        // eslint-disable-next-line complexity
        const searchHandle = (val) => {
            searchData.value = _.cloneDeep(val);
            if (val.industryCategory?.length) {
                searchData.value.typeId = val.industryCategory.map(it => it[0]);
            } else {
                searchData.value.typeId = [];
            }

            searchData.value.ebcdCode = setCommaStrFormat(searchData.value.ebcdCode) || "'all'"; // 专业公司编码
            searchData.value.typeId = setStrFormat(searchData.value.typeId) || "'all'"; // 行业大类
            searchData.value.areaCode = setStrFormat(searchData.value.areaCode) || "'all'"; // 片区
            searchData.value.subBranchCode = setStrFormat(searchData.value.subBranchCode) || "'all'"; // 分公司
            searchData.value.businessSceneBigCategory = setStrFormat(searchData.value.businessSceneBigCategory) || "'all'"; // 业务场景
            const needParams = {};
            if (props.needCostType) {
                needParams.costType = isYear.value ? '2' : '1';
            }

            subTabTable.pageNo.value = 1;
            subTabTable.getList();
            if (props.config.page) {
                const afterResponseBeforeReq = _.get(props.config, 'afterResponseBeforeRequest');
                totalNum.value = afterResponseBeforeReq ? 1 : 0;
                // 默认查0
                // eslint-disable-next-line no-magic-numbers
                getPageTotal({ pageNo: 1, pageSize: props.config.pageSize || 300 });
            }
        };
        const totalNum = ref(0);
        // eslint-disable-next-line no-magic-numbers
        const getPageTotal = ({ pageNo, pageSize }) => {
            // eslint-disable-next-line no-magic-numbers
            if (pageNo > 70) return;
            const page = {
                pageNo: pageNo || 0,
                // eslint-disable-next-line no-magic-numbers
                pageSize: pageSize || 300
            };
            const newPage = _.cloneDeep(page);
            if (props.config.page) {
                if (newPage.pageNo === 1) {
                    newPage.pageNo = 0;
                } else if (newPage.pageNo > 1) {
                    newPage.pageNo = (newPage.pageNo - 1) * newPage.pageSize;
                }
            }
            const api = props.config.listApi;
            const params = { ...props.getParams, ...setParamsList(), ...newPage };

            if (qName.value !== '') {
                params.qName = `'${qName.value}'`;
            }
            // 执行外部传入的请求前处理函数
            if (props.beforeRequest && typeof props.beforeRequest === 'function') {
                Object.assign(params, props.beforeRequest(params));
            }
            api(params).then(res => {
                if (res && +res.code === 0 && res.data.length) {
                    totalNum.value = (totalNum.value + Number(res.data?.length)) || 0;
                    // eslint-disable-next-line no-magic-numbers
                    if (res.data?.length === params.pageSize) {
                        getPageTotal({ pageNo: ++page.pageNo, pageSize });
                    }
                } else {
                    totalNum.value = params.pageNo === 0 ? 0 : totalNum.value;
                }
            }).catch(() => {
                totalNum.value = 0;
            });
        };
        const setParamsList = () => {
            const needParams = {};
            if (props.needCostType) {
                needParams.costType = isYear.value ? '2' : '1';
            }
            return {
                ..._.pick(searchData.value, [
                    'customerlevelName'
                ]),
                customerLevelName: searchData.value.customerlevelName,
                // qName: `'所有'`,
                ...{
                    ...needParams,
                    ...otherParams.value,
                    type: isYear.value ? props.config.yearType : props.config.monthType,
                    dataType: isYear.value ? 'Y' : 'M',
                    dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime
                }
            };
        };
        const openDialog = (row) => {
            emit('openCustomerGroup', {
                ...otherParams.value,
                industryCode: row.industryCode,
                row,
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime
            });
        };
        const openSiteDialog = (row) => {
            emit('openCustomerGroup', {
                ...otherParams.value,
                siteCodeLev2: row.siteCodeLev2,
                row,
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime
            });
        };
        const openCustomerDialog = (row) => {
            emit('openCustomerDetail', {
                ...otherParams.value,
                customerName: row.customerName,
                row,
                dataType: isYear.value ? 'Y' : 'M',
                dataTime: isYear.value ? searchData.value.yearTime : searchData.value.monthTime
            });
        };
        const getMonthConfig = () => {
            const columns = _.cloneDeep(props.config.tableData.columnsMonth);
            if (props.config.columnsFunc) {
                let _col = [];
                const colFunc = _.get(props.config, 'columnsFunc');
                if (colFunc && _.isFunction(colFunc)) {
                    _col = colFunc(props.config.tableData.columnsMonth, searchData.value.monthTime);
                }
                return _col;
            }
            return columns;
        };
        const getYearConfig = () => {
            const columns = _.cloneDeep(props.config.tableData.columnsYear);
            if (props.config.columnsFunc) {
                let _col = [];
                const colFunc = _.get(props.config, 'columnsFunc');
                if (colFunc && _.isFunction(colFunc)) {
                    _col = colFunc(props.config.tableData.columnsYear, searchData.value.yearTime);
                }
                return _col;
            }
            return columns;
        };
        const tableKey = ref(1);
        const _columns = computed(() => {
            tableKey.value++;
            return isYear.value ? getYearConfig() : getMonthConfig();
        });
        const showInput = computed(() => {
            return props.getParams?.qName;
        });
        const orderBy = ref('');
        const orderByType = ref('');
        // 排序
        const handleSort = ({ prop, order }) => {
            // 查找当前列的配置
            const currentColumn = _columns.value.find(it => it.prop === prop);
            const customSortMethod = currentColumn?.customSortMethod;

            // 如果存在 sortMethod，使用客户端排序（Element UI 会自动处理）
            if (customSortMethod) {
                subTabTable.totalData.value = customSortMethod(prop, order, subTabTable.totalData.value) || [];
                // 客户端排序，不需要调用接口
            } else {
                // 服务端排序，更新排序参数并调用接口
                orderBy.value = prop;
                orderByType.value = order === 'ascending' ? 'asc' : 'desc';
                subTabTable.getList();
            }
        };
        onMounted(() => {
        });
        const qName = ref('');
        const inputChange = () => {
            subTabTable.getList();
            if (props.config.page) {
                const afterResponseBeforeReq = _.get(props.config, 'afterResponseBeforeRequest');
                totalNum.value = afterResponseBeforeReq ? 1 : 0;
                // 默认查0
                // eslint-disable-next-line no-magic-numbers
                getPageTotal({ pageNo: 1, pageSize: props.config.pageSize || 300 });
            }
        };
        return {
            ...toRefs(state),
            emit,
            visibleDialog,
            confirm,
            show,
            subTabTable,
            visibleSearch,
            changeIconActive,
            currentOptions,
            dataChanged,
            respVersion,
            searchHandle,
            openDialog,
            _columns,
            tableKey,
            getCellClass,
            openCustomerDialog,
            totalNum,
            openSiteDialog,
            inputChange,
            qName,
            showInput,
            handleSort
        };
    }
};
</script>
<style lang="less" scoped>
.icon-active {
  color: #4285f5 !important;
}

.price-icon {
  font-size: 12px;
  cursor: pointer;
  color: #000;
}

.bg-color {
  background: red;
}

.status-color {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.tips-status-color {
  background-color: #f78900 !important;
}

.error-status-color {
  background-color: #f44336 !important;
}

.reg-dialog {
  .change-btn-box {
    padding: 9px 14px 0 14px;
    display: flex;
    flex-direction: column;
    // min-height: 397px;
    height: 501px;

    .el-button {
      margin: 10px 20px;
      padding: 0 20px;
    }
  }

  .change-radio {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .radio-label {
      width: 36px;
    }
  }

  .radio-text {
    margin-right: 12px;
    font-size: 16px;
    display: inline-block;
    min-width: 80px;
  }

  .confirm-btn {
    width: 60px;
    height: 32px;
    background: linear-gradient(133deg, #69a7ff 0%, #2881ff 100%);
  }

  .cancel-btn {
    width: 60px;
    height: 32px;
    background: #fff;
    border-radius: 3px;
    border: 1px solid #c0c5cf;
  }
}

.c-item-up-bg {
  color: #0bb861;
}

.c-item-down-bg {
  color: #f44837;
}

.income-pagination-page {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="less">
/* .reg-dialog .change-btn-box .el-table__body-wrapper tr:last-child td {
    font-weight: 600;
} */
.reg-dialog .radio-label .el-radio__label {
  line-height: 16px;
}

.reg-dialog .el-table__body-wrapper {
  height: 100% !important;
}

.customer-table {
  overflow: auto;

  .mip-page-link {
    color: #4285f5;
    cursor: pointer;

    &.no-wrap {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.home-dialog-table::before {
  height: 0;
}
</style>
